module.exports = __webpack_public_path__ + "img/escalier + garde-corps.a518ed4f.jpg";